<template>
  <div class="text-red-500 text-xs mb-1"><slot></slot> {{ '&nbsp;' }}</div>
</template>

<script setup lang="ts"></script>
